import { trackSuccessAttempt, } from '../../common/buildPayloadsTyped/trackSuccessAttempt.js';
export const trackAppleAttemptSuccessfulRequest = (params) => {
    return trackSuccessAttempt({
        ...params,
        loginMethod: 'apple',
        uniqueName: 'appleAuthentication',
    });
};
//# sourceMappingURL=trackAppleAttemptSuccessfulRequest.js.map